import { Typography } from '@material-ui/core';
import { useStyles } from './noIncidents.style';

type IncidentCardProps = {
  daysWithoutIncidents: number;
};

const NoIncidents = ({ daysWithoutIncidents }: IncidentCardProps) => {
  const { cx, classes } = useStyles();

  return (
    <>
      <Typography variant="body1" className={cx(classes.noIncidentsText)}>
        All is going well, <span> 0 incidents</span> ongoing across SCALAR and
        SKY.
      </Typography>
      <Typography variant="h1" className={cx(classes.number)}>
        {daysWithoutIncidents}
      </Typography>
      <Typography
        variant="body1"
        className={cx(classes.daysWithoutIncidentstext)}
      >
        days without a P1 production incident!
      </Typography>
    </>
  );
};

export { NoIncidents };
